<header class="background-header">
    <img [ngClass]="{backgroundWidth:themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}"
        src="../../assets/img/{{ themeService.theme }}/header-background.svg" alt class="background-header-img" />
</header>
<app-loader *ngIf="!dataIsLoaded"></app-loader>
<section *ngIf="myUser" [ngClass]="{hideOnMobile: sideNavBarVisibilityService.hideOnMobile == true,
    'main-side-nave-theme':themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}" class="main-side-nav">
    <section class="container account-settings-container">
        <section class="template-section-title">
            <div class="breadcrumb-container">
                <span>
                    My Plan
                    <i class="fa fas fa-chevron-right"></i>
                </span>
                <app-breadcrumb [pageName]="'Account Settings'" [isTopLevel]="true">
                </app-breadcrumb>
            </div>
            <div class="title-container">
                <h1>
                    Manage Account
                    <!-- <span *ngIf="dataSponsor">- {{dataSponsor.company}}</span> -->
                    <span *ngIf="myUser.userType == 'planHolder' && !dataSponsor">
                        - {{ myUser.firstName + " " + myUser.lastName }}
                    </span>
                </h1>
            </div>
        </section>
        <div class="notification-bubble-container">
            <app-notification-bubble *ngIf="aboutMeFormGroup != invalid || passwordFormGroup != invalid">
            </app-notification-bubble>
        </div>
        <section *ngIf="dataIsLoaded">
            <section class="account-settings-section">
                <!-- Tab -->
                <div (click)="openMobileMenu()" class="mobile-tab">
                    <div class="open-menu-mobile-tab">
                        <div>Open Menu</div>
                        <div [ngClass]="statusMobileMenu ? 'chevron-collapsed' : ''">
                            <i class="fa fas fa-chevron-down"></i>
                        </div>
                    </div>
                </div>
                <section [ngClass]="statusMobileMenu ? 'tab-collapsed' : ''" [class.tabHeightPro]="myUser.userType == 'professional' || 
                                          showSideNav == 'top' || 
                                          myUser.userType == 'professionalManager'" class="tab">
                    <div *ngIf="!hasPlan || (myUser.userType && myUser.userType != 'admin')"
                        [ngClass]="{ activeTab: chosenTab == 'aboutMe' }" [routerLink]="['/account-settings/aboutMe']"
                        (click)="openTab('aboutMe')" class="tablinks" id="aboutMeBtn">
                        <span>About Me</span>
                        <div class="triangle"></div>
                    </div>
                    <!-- div *ngIf="myUser.userType && myUser.userType != 'professional'" class="tablinks" [ngClass]="{activeTab:chosenTab=='payment'}"
						 (click)="openTab(event, 'payment')">
						<span>Payment</span>
						<div class="triangle"></div>
					</div -->
                    <div *ngIf="!hasPlan || (myUser.userType && myUser.userType != 'admin')"
                        [ngClass]="{ activeTab: chosenTab == 'password' }" [routerLink]="['/account-settings/password']"
                        (click)="openTab('password')" class="tablinks">
                        <span>Password</span>
                        <div class="triangle"></div>
                    </div>
                    <div *ngIf="displayItemsOwner
                              && (myUser && myUser.userType != 'admin') 
                              && (myUser && myUser.userType != 'professional')
                              && (myUser && myUser.userType != 'professionalManager')"
                        [ngClass]="{ activeTab: chosenTab == 'itemOwners' }"
                        [routerLink]="['/account-settings/itemOwners']" (click)="openTab('itemOwners')"
                        class="tablinks">
                        <span>Item Owners</span>
                        <div class="triangle"></div>
                    </div>
                    <div *ngIf="!hasPlan || (myUser.userType && myUser.userType != 'admin')"
                        [ngClass]="{ activeTab: chosenTab == 'antiPhishingCode' }"
                        [routerLink]="['/account-settings/antiPhishingCode']" (click)="openTab('antiPhishingCode')"
                        class="tablinks">
                        <span>Anti Phishing Code</span>
                        <div class="triangle"></div>
                    </div>
                    <div *ngIf="myUser.userType && myUser.userType != 'admin'"
                        [ngClass]="{ activeTab: chosenTab == 'contactReferences' }"
                        (click)="openTab('contactReferences')" class="tablinks">
                        <span>Contact Preferences</span>
                        <div class="triangle"></div>
                    </div>
                    <div *ngIf="myUser.userType && myUser.userType != 'professional' && 
                                myUser.userType && myUser.userType != 'professionalManager' && 
                                myUser.userType && myUser.userType != 'admin'"
                        [ngClass]="{ activeTab: chosenTab == 'planUpdates' }"
                        [routerLink]="['/account-settings/planUpdates']" (click)="openTab('planUpdates')"
                        class="tablinks">
                        <span>Plan Update</span>
                        <div class="triangle"></div>
                    </div>
                    <div [ngClass]="{ activeTab: chosenTab == 'security' }"
                        [routerLink]="['/account-settings/security']" (click)="openTab('security')" class="tablinks">
                        <span>Security</span>
                        <div class="triangle"></div>
                    </div>
                    <div *ngIf="myUser.userType && myUser.userType != 'professional' && 
                                myUser.userType && myUser.userType != 'professionalManager' && 
                                myUser.userType && myUser.userType != 'admin'"
                        [ngClass]="{ activeTab: chosenTab == 'exportData' }" (click)="openTab('exportData')"
                        class="tablinks">
                        <span>Export Plan</span>
                        <div class="triangle"></div>
                    </div>
                    <div *ngIf="myUser.userType && myUser.userType != 'admin'"
                        [ngClass]="{ activeTab: chosenTab == 'cancelZenplans' }"
                        [routerLink]="['/account-settings/cancelZenplans']" (click)="openTab('cancelZenplans')"
                        class="tablinks">
                        <span>
                            Cancel
                            <span *ngIf="activeTheme.name == 'defaultTheme'">Zenplans</span>
                        </span>
                        <div class="triangle"></div>
                    </div>
                </section>
                <section class="tab-info-user">
                    <!-- About Me -->
                    <section class="about-me tabcontent hide-category floating-form" id="aboutMe">
                        <form [formGroup]="aboutMeFormGroup" class="form-account about-me-form">
                            <div *ngIf="myUser.userType == 'professional' || 
                                        myUser.userType == 'professionalManager'" class="form-group floating-label">
                                <input [ngClass]="{ 'is-invalid': submitted && f.company.errors }" type="text"
                                    class="form-control floating-input" id="company" placeholder required
                                    formControlName="company" />
                                <span class="highlight"></span>
                                <label class="effect-label">Company</label>
                                <div *ngIf="submitted && f.company.errors" class="invalid-feedback">
                                    <div *ngIf="f.company.errors.required">
                                        Company is required
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="myUser.userType == 'professionalManager'" class="form-group dynamic-dropdown">
                                <app-dynamic-dropdown [myLabel]="'profession'" [id]="professionalProfession"
                                    [optionCollection]="professionalProfession" [optionViewProperty]="opt"
                                    [optionValueProperty]="opt" formControlName="professionalProfession">
                                </app-dynamic-dropdown>
                            </div>
                            <div class="form-group floating-label">
                                <input [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" type="text"
                                    class="form-control floating-input" id="firstName2" placeholder required
                                    formControlName="firstName" />
                                <span class="highlight"></span>
                                <label class="effect-label">First Name</label>
                                <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                                    <div *ngIf="f.firstName.errors.required">
                                        First Name is required
                                    </div>
                                </div>
                            </div>
                            <!-- <div>
                                <input type="date" placeholder="05-Sep-2024" pattern="\d{2}-[A-Za-z]{3}-\d{4}" title="Format: DD-MMM-YYYY">
                            </div> -->
                            <div class="form-group floating-label">
                                <input [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" type="text"
                                    class="form-control floating-input" id="lastName2" placeholder required
                                    formControlName="lastName" />
                                <span class="highlight"></span>
                                <label class="effect-label">Last Name</label>
                                <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                    <div *ngIf="f.lastName.errors.required">
                                        Last Name is required
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="
                  myUser.userType != 'professional' &&
                  myUser.userType != 'professionalManager'
                " class="form-group floating-label">
                                <input [ngClass]="{
                    'is-invalid': submitted && f.dateOfBirth.errors
                  }" type="text" class="form-control floating-input" id="dateOfBirth" required
                                    formControlName="dateOfBirth" placeholder />
                                <span class="highlight"></span>
                                <label class="effect-label">Date of Birth</label>
                                <div *ngIf="submitted && f.dateOfBirth.errors" class="invalid-feedback">
                                    <div *ngIf="f.dateOfBirth.errors.required">
                                        Date of birth is required
                                    </div>
                                </div>
                            </div>
                            <div class="form-group floating-label">
                                <input [ngClass]="{ 'is-invalid': submitted && f.phoneNumber.errors}" type="text"
                                    class="form-control floating-input" id="phoneNumber" placeholder
                                    formControlName="phoneNumber" />
                                <span class="highlight"></span>
                                <label class="effect-label">Phone Number</label>
                                <div *ngIf="submitted && f.phoneNumber.errors" class="invalid-feedback">
                                    <div *ngIf="f.phoneNumber.errors.required">
                                        Phone number is required
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="myUser.userType == 'professionalManager'" class="form-group floating-label">
                                <input [ngClass]="{'is-invalid': submitted && f.professionalAddress.errors}" type="text"
                                    class="form-control floating-input" id="address" placeholder required
                                    formControlName="professionalAddress" />
                                <span class="highlight"></span>
                                <label class="effect-label">Address</label>
                                <div *ngIf="submitted && f.professionalAddress.errors" class="invalid-feedback">
                                    <div *ngIf="f.professionalAddress.errors.required">
                                        Address is required
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="myUser.userType != 'professional'" class="form-group floating-label">
                                <input [ngClass]="{ 'is-invalid': submitted && f.postCode.errors }" type="text"
                                    class="form-control floating-input" id="postCode2" placeholder
                                    formControlName="postCode" />
                                <span class="highlight"></span>
                                <label class="effect-label">Post Code</label>
                                <div *ngIf="submitted && f.postCode.errors" class="invalid-feedback">
                                    <div *ngIf="f.postCode.errors.required">
                                        Post Code is required
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="myUser.userType != 'professional' && myUser.userType != 'professionalManager'"
                                class="form-group dynamic-dropdown">
                                <app-dynamic-dropdown [myLabel]="'Country'" [id]="country"
                                    [optionCollection]="myCountries" [optionViewProperty]="opt"
                                    [optionValueProperty]="opt" formControlName="country">
                                </app-dynamic-dropdown>
                            </div>
                            <div class="form-group">
                                <input (click)="saveAboutMe()" type="button" class="btn btn-primary primary-lg-btn"
                                    value="Submit" />
                            </div>
                        </form>
                        <!-- <section class="photo-user">
                            <div class="img-container">
                                <img *ngIf="!hideBrokenImage"
                                    (click)="uploadLogo.click()"
                                    (error)="hideErrorImage()"
                                    [src]="avatarUrl" alt="User's Avatar"
                                    width="100px" />
                                <img *ngIf="hideBrokenImage"
                                    (click)="uploadLogo.click()"
                                    src="../../assets/img/{{themeService.theme}}/account-settings-user-fa.svg" />
                            </div>
                            <div class="box zp-upload-file">
                                <form method="post"
                                    enctype="multipart/form-data"
                                    class="inputfile inputfile-3"
                                    style="display: none">
                                    <input #uploadLogo
                                        (change)="fileUpload($event)"
                                        type="file" accept="image/*" />
                                </form>
                                <label (click)="uploadLogo.click()">
                                    <span class="upload-photo-text">Upload Photo</span>
                                </label>
                            </div>
                        
                            <div *ngIf="message" class="error-upload" role="alert">
                                {{ message }}
                            </div>
                            <div *ngIf="!dataIsLoaded" class="upload-loader">
                                <app-loader *ngIf="!dataIsLoaded"></app-loader>
                            </div>
                        </section> -->
                    </section>
                    <!-- Payment -->
                    <section *ngIf="myUser.userType != 'professional'" class="payment tabcontent hide-category"
                        id="payment">
                        <form [formGroup]="paymentFormGroup" class="form-account payment-form">
                            <div class="form-group">
                                <input type="text" formControlName="ccHolder" class="form-control"
                                    placeholder="Card Holder Name" />
                            </div>
                            <div class="form-group">
                                <input type="text" formControlName="ccNumber" class="form-control"
                                    placeholder="Card Number" />
                            </div>
                            <div class="form-group">
                                <input type="text" formControlName="ccExpire" class="form-control"
                                    placeholder="Expiration MM/YY" />
                            </div>
                            <div class="form-group update-btn">
                                <input (click)="savePayment()" type="button" class="btn btn-primary primary-lg-btn"
                                    value="Save Changes" />
                            </div>
                        </form>
                    </section>
                    <!-- Password -->
                    <section class="password tabcontent hide-category" id="password">
                        <form class="form-account password-form">
                            <div [formGroup]="passwordFormGroup" class="form-group caps-lock-section floating-form">
                                <div class="form-group floating-label">
                                    <input [type]="statusPassword ? 'text' : 'password'"
                                        [ngClass]="{ 'is-invalid': submitted && g.password.errors }"
                                        (capsLock)="capsOn = $event" formControlName="password"
                                        class="form-control floating-input" placeholder id="password2" />
                                    <i (click)="statusPassword = !statusPassword"
                                        class="caps-lock-icon-1 fa fas fa-eye"></i>
                                    <i [ngClass]="!statusPassword ? 'eye-slash' : ''"
                                        (click)="statusPassword = !statusPassword" class="eye-slash"
                                        class="fa fas fa-eye-slash"></i>
                                    <span class="highlight"></span>
                                    <label class="effect-label">New Password</label>
                                    <div *ngIf="capsOn" class="warning-caps-locked">
                                        Caps Locked
                                    </div>
                                    <div *ngIf="submitted && g.password.errors" class="invalid-feedback">
                                        <div *ngIf="g.password.errors.required && isInvalid">
                                            Password is required
                                        </div>
                                        <div *ngIf="g.password.errors.minlength">
                                            Must be at least 10 characters
                                        </div>
                                        <div *ngIf="g.password.errors.hasCapitalCase">
                                            Must contain at least 1 upper case character
                                        </div>
                                        <div *ngIf="g.password.errors.hasSmallCase">
                                            Must contain at least 1 lower case character
                                        </div>
                                        <div *ngIf="g.password.errors.hasNumber">
                                            Must contain at least 1 number
                                        </div>
                                        <div *ngIf="g.password.errors.hasSpecialSymbol">
                                            Must contain at least 1 special character
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group floating-label">
                                    <input [type]="statusOldPassword ? 'text' : 'password'"
                                        [ngClass]="{'is-invalid': submitted && g.oldPassword.errors}"
                                        (capsLock)="capsOn = $event" formControlName="oldPassword"
                                        class="form-control floating-input" id="oldPassword2" placeholder />
                                    <i (click)="statusOldPassword = !statusOldPassword"
                                        class="caps-lock-icon-2 fa fas fa-eye"></i>
                                    <i [ngClass]="!statusOldPassword ? 'eye-slash' : ''"
                                        (click)="statusOldPassword = !statusOldPassword" class="eye-slash"
                                        class="fa fas fa-eye-slash"></i>
                                    <span class="highlight"></span>
                                    <label class="effect-label">Old Password</label>
                                    <div *ngIf="submitted && g.oldPassword.errors" class="invalid-feedback">
                                        <div *ngIf="g.oldPassword.errors.required && isInvalid">
                                            Old password is required.
                                        </div>
                                    </div>
                                    <div [ngClass]="{showError: zenplansDataService.passwordError == true}"
                                        class="wrong-password">
                                        Your old password is invalid
                                    </div>
                                </div>
                            </div>
                            <div class="form-group update-btn">
                                <input (click)="savePassword()" type="button" class="btn btn-primary primary-lg-btn"
                                    value="Save Changes" />
                            </div>
                        </form>
                    </section>

                    <!-- Item Owners -->
                    <section class="itemOwners tabcontent hide-category" id="itemOwners">
                        <section *ngIf="!displayOwnerForm" class="item-owners-content">
                            <div class="title-section">
                                Here you can manage the people that own the
                                items in your plan.
                            </div>

                            <div class="owners-btns">
                                <input (click)="add()" value="Create owner" type="button"
                                    class="btn-primary primary-default-btn create-owner-btn" />
                                <input *ngIf="hideBackBtn==false" (click)="backToPlan()" value="Back to item"
                                    type="button" class="btn-primary primary-default-btn back-to-plan-btn" />
                            </div>

                            <!-- User's Owners -->
                            <div class="dynamic-collapse" *ngFor="let owner of jointOwnersList; let i = index">
                                <div class="dynamic-collapse-header-toggle"
                                    [ngClass]="{'dynamic-collapse-header-collapsed':selectedOwner == i}">
                                    <div class="owner-box">
                                        <div class="owner-info">
                                            {{ owner.first + " " + owner.last }}
                                        </div>
                                        <div class="owner-buttons">
                                            <div class="edit-btn-group" *ngIf="!owner.default">
                                                <input type="button" value="Edit"
                                                    class="btn btn btn-primary primary-sml-btn view"
                                                    (click)="editOwner(i)" />
                                                <i class="fa fas fa-pencil-alt"></i>
                                            </div>
                                            <div class="delete-btn-group" *ngIf="!owner.default">
                                                <input type="button" value="Delete"
                                                    class="btn btn-primary primary-sml-btn delete"
                                                    (click)="deleteOwner(i, owner)" />
                                                <i class="fa fas fa-trash"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="dynamic-collapse-main">
                                    <div [ngClass]="{'dynamic-collapse-content':selectedOwner == i}">
                                        <div [ngClass]="{'hide':selectedOwner!=i,'expanded':selectedOwner == i}"
                                            *ngIf="editCurrentOwner" class="edit-form"
                                            [formGroup]="itemOwnersFormGroup">
                                            <div class="input-managment">
                                                <div class="form-group-input first-last-inputs">
                                                    <input type="text" class="form-control floating-input" id="first"
                                                        [(ngModel)]="currentOwner.first" formControlName="first"
                                                        placeholder="First Name" required />
                                                    <input type="text" class="form-control floating-input" id="last"
                                                        [(ngModel)]="currentOwner.last" formControlName="last"
                                                        placeholder required />
                                                </div>
                                                <div class="form-group-input email-relationship-inputs">
                                                    <input type="text" class="form-control floating-input"
                                                        id="relationship" [(ngModel)]="currentOwner.relationship"
                                                        formControlName="relationship" placeholder required />
                                                </div>
                                            </div>
                                            <div class="btn-managment">
                                                <div class="form-group back-btn">
                                                    <input (click)="backFromEditOwner()" type="button"
                                                        class="btn btn-primary primary-lg-btn" value="Back to item" />
                                                </div>
                                                <div class="form-group save-btn">
                                                    <input (click)="saveOwner(owner, i)" type="button"
                                                        class="btn btn-primary primary-lg-btn" value="Save Edit" />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Display Form to add a new owner -->
                        <div *ngIf="displayOwnerForm" [formGroup]="itemOwnersFormGroup" class="form-item-owners">
                            <section class="form-section">
                                <div class="form-group floating-label">
                                    <input [ngClass]="{ 'is-invalid': submitted && h.first.errors}" type="text"
                                        class="form-control floating-input" id="first" placeholder required
                                        formControlName="first" />
                                    <span class="highlight"></span>
                                    <label class="effect-label">First Name</label>
                                    <div *ngIf="submitted && h.first.errors" class="invalid-feedback">
                                        <div *ngIf="h.first.errors.required">
                                            First Name is required
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group floating-label">
                                    <input [ngClass]="{'is-invalid': submitted && h.last.errors}" type="text"
                                        class="form-control floating-input" id="last" placeholder required
                                        formControlName="last" />
                                    <span class="highlight"></span>
                                    <label class="effect-label">Last Name</label>
                                    <div *ngIf="submitted && h.last.errors" class="invalid-feedback">
                                        <div *ngIf="h.last.errors.required">
                                            Last Name is required
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group floating-label">
                                    <input [ngClass]="{'is-invalid': submitted && h.relationship.errors}" type="text"
                                        class="form-control floating-input" id="relationship" placeholder required
                                        formControlName="relationship" />
                                    <span class="highlight"></span>
                                    <label class="effect-label">relationship</label>
                                    <div *ngIf="submitted && h.relationship.errors" class="invalid-feedback">
                                        <div *ngIf="h.relationship.errors.required">
                                            Relationship is required
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section class="btn-section">
                                <div class="form-group update-btn">
                                    <input (click)="back()" type="button" class="btn btn-primary primary-lg-btn"
                                        value="Back" />
                                </div>
                                <div class="form-group update-btn">
                                    <input (click)="addNewOwner()" type="button" class="btn btn-primary primary-lg-btn"
                                        value="Save Changes" />
                                </div>
                            </section>
                        </div>
                    </section>

                    <!-- Anti Phishing Code -->
                    <section class="anti-phishing-code tabcontent hide-category" id="antiPhishingCode">
                        <form class="form-account anti-phishing-code-form">
                            <div [formGroup]="antiPhishingCodeFormGroup" class="form-group floating-form">
                                <div class="explanations">
                                    <div class="first-para">
                                        <div class="title">What is an
                                            Anti-Phishing Code?</div>
                                        <p>
                                            An Anti-Phishing Code is a code that
                                            helps to prevent
                                            phishing attempts from fake websites
                                            or email addresses.
                                        </p>
                                    </div>
                                    <div class="scd-para">
                                        <div class="title">How does it work?</div>
                                        <p>
                                            Once you've set your unique
                                            Anti-Phishing Code, it will be
                                            included in all genuine emails from
                                            us.
                                        </p>
                                    </div>
                                </div>
                                <div class="create-code" style="position: relative">
                                    <input type="text" placeholder formControlName="createAntiPhishingCode"
                                        class="form-control floating-input" />
                                    <span class="highlight"></span>
                                    <label class="effect-label">
                                        Enter a code of your choice
                                    </label>
                                </div>

                                <div class="form-group update-btn">
                                    <input (click)="createAntiPhishingCode()" type="button"
                                        class="btn btn-primary primary-lg-btn" value="Create Anti-Phishing Code" />
                                </div>
                            </div>
                        </form>
                    </section>

                    <!-- Contact References -->
                    <section class="contact-references tabcontent hide-category" id="contactReferences">
                        <form [formGroup]="contactReferencesFormGroup" class="form-account contact-form">
                            <div class="checkbox-updates">
                                <div class="custom-control custom-switch">
                                    <div class="send-updates">
                                        Send me occasional new updates and
                                        special offers.
                                    </div>
                                    <div class="checkbox">
                                        <input [ngModel]="updateIsCheked" [checked]="updateIsCheked"
                                            (change)="updateIsClicked(updateIsCheked)" type="checkbox" class="mytoggle"
                                            id="customSwitch1" formControlName="offersAuthorization" />
                                        <label for="customSwitch1"></label>
                                    </div>
                                    <div *ngIf="updateIsCheked" class="custom-switch-answer">
                                        Yes
                                    </div>
                                    <div *ngIf="!updateIsCheked" class="custom-switch-answer">
                                        No
                                    </div>
                                </div>
                                <div *ngIf="myUser.userType != 'professional' &&myUser.userType != 'professionalManager'"
                                    class="custom-control custom-switch">
                                    <div class="send-updates">
                                        Send me reminders to update my plan.
                                    </div>
                                    <div class="checkbox">
                                        <input [ngModel]="reminderIsCheked" [checked]="reminderIsCheked"
                                            (change)="reminderIsClicked(reminderIsCheked)" type="checkbox"
                                            class="mytoggle" id="customSwitch2"
                                            formControlName="sendPlanUpdateReminders" />
                                        <label for="customSwitch2"></label>
                                    </div>
                                    <div *ngIf="reminderIsCheked" class="custom-switch-answer">
                                        Yes
                                    </div>
                                    <div *ngIf="!reminderIsCheked" class="custom-switch-answer">
                                        No
                                    </div>
                                </div>
                            </div>
                            <div class="form-group update-btn">
                                <input (click)="saveContactReferences()" type="button"
                                    class="btn btn-primary primary-lg-btn" value="Save Changes" />
                            </div>
                        </form>
                    </section>
                    <!-- Plan Updates -->
                    <section *ngIf="myUser.userType != 'professional' &&myUser.userType != 'professionalManager'"
                        class="plan-update tabcontent hide-category" id="planUpdates">
                        <form [formGroup]="planUpdateFormGroup" class="form-account update-form">
                            <div class="form-group plan-update-text">
                                Our lives are always changing, so it is
                                important to regularly
                                review and update your plan.
                            </div>
                            <div class="form-group plan-update-text">
                                How often would you like us to remind you to
                                update your plan?
                            </div>
                            <div class="form-group">
                                <label for class="ovale"> Plan Reminder
                                    Frequency </label>
                                <select class="form-control" formControlName="planUpdateReminder">
                                    <option>Every 3 Months</option>
                                    <option>Every 6 Months</option>
                                    <option>Once a Year</option>
                                </select>
                            </div>
                            <div class="form-group update-btn">
                                <input (click)="savePlanUpdate()" type="button" class="btn btn-primary primary-lg-btn"
                                    value="Save Changes" />
                            </div>
                        </form>
                    </section>
                    <!-- Security -->
                    <section class="security tabcontent hide-category" id="security">
                        <form [formGroup]="securityFormGroup" class="form-group form-account security-form">
                            <div class="form-group">
                                Select whether you want to be sent a
                                verification email/SMS evey
                                time you wish to log in.
                            </div>
                            <div class="form-group">
                                <label for class="ovale"> Require MFA with every
                                    login? </label>
                                <select class="form-control" formControlName="mfaAlways">
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label for class="ovale"> Receive MFA via
                                </label>
                                <select class="form-control" formControlName="mfaVia" [(ngModel)]="selectedMfaVia"
                                    (change)="onChangeMfaVia(selectedMfaVia)">
                                    <option [selected]="myUser.mfaVia === 'Email'" [value]="'Email'">Mail</option>
                                    <option [selected]="myUser.mfaVia === 'SMS'" [value]="'SMS'">SMS</option>
                                </select>
                                <i class="invalid"
                                    *ngIf="(!myUser.phoneNumber || myUser.phoneNumber == '') && smsError">
                                    In order to be able to receive MFA
                                    tokens via SMS
                                    you need to make sure your phone number has
                                    been set in your account.</i>
                                <i *ngIf="myUser.phoneNumber && myUser.phoneNumber != ''">
                                    If you choose
                                    SMS please ensure your provided phone
                                    number {{myUser.phoneNumber}} is correct.
                                    (You can change it in the About Me
                                    section.)</i>
                            </div>

                            <div class="form-group update-btn">
                                <input (click)="saveSecurity(selectedMfaVia)" type="button"
                                    class="btn btn-primary primary-lg-btn" value="Save Changes" />
                            </div>
                        </form>
                    </section>

                    <!-- Export -->
                    <section class="exportData tabcontent hide-category" id="exportData">
                        <div class="title">
                            Export your plan data here
                        </div>
                        <div class="export-data-button">
                            <input (click)="exportData()" type="button" class="btn btn-primary primary-lg-btn"
                                value="Export Plan" />
                        </div>
                    </section>

                    <!-- cancel Zenplans -->
                    <section class="cancel-zenplans tabcontent hide-category" id="cancelZenplans">
                        <form class="form-account cancel-form">
                            <ng-container *ngIf="showStep1Warning==true">
                                <div *ngIf="myUser.userType && myUser.userType != 'professional'"
                                    class="form-group cancel-text">
                                    <div class="step1-title">Delete your account</div>
                                    If you no longer wish to use
                                    <span *ngIf="activeTheme.name != 'defaultTheme'">
                                        your plan
                                    </span>
                                    <span *ngIf="activeTheme.name == 'defaultTheme'">Zenplans</span>, then please click the button below.
                                </div>
                                <div class="alert alert-warning" role="alert">
                                    Please export your plan data <strong>via your account settings</strong> before deleting your account. <br>
                                    Deleting your account will permanently delete your plan data.
                                </div>
                                <div class="form-group cancel-btn">
                                    <input (click)="stepToDeleteAccountMFA()" type="button"
                                        class="btn btn-primary primary-lg-btn" value="Delete Account" />
                                </div>
                            </ng-container>
                            <div class="show-mfa-step" *ngIf="showStep2MFA">
                                <div class="step2MFA-title">Confirm account deletion</div>
                                <div class="step2MFA-description">For your security, we have sent an authentication
                                    code to you via SMS/Email before your account and plan is deleted.</div>
                                <div class="step2MFA-code-container">
                                    <input type="text" placeholder="Enter Code" #codeInput>
                                    <section class="form-group forgot-info resend-code">
                                        <input (click)="resendMFA()" [disabled]="resendCodeDisabled" value="Resend code"
                                            [ngClass]="{'disabled-btn': resendCodeDisabled}">
                                        <span class="counter" *ngIf="resendCodeDisabled">
                                            You can resend a new one in {{ counter }} seconds.
                                        </span>
                                    </section>
                                </div>
                                <div class="mfa-fail" *ngIf="MFAFail">MFA code is invalid. Please try again.</div>
                                <input type="button" value="Verify and Delete"
                                    class="step2MFA-confirm-btn btn btn-primary primary-lg-btn"
                                    (click)="verifyMfaAndDelete(codeInput.value)" />
                            </div>
                            <div class="show-msg-deletion-step" *ngIf="showStep3Deletion">
                                <div class="step3Deletion-title">Account deleted</div>
                                <div class="step3Deletion-description">
                                    Your account and plan data have been deleted, a copy of your plan data has been exported to your device.<br>
                                    Thank you for using Zenplans.
                                </div>
                                <div class="count">You will be log out in {{ logoutTimer }} seconds.</div>
                            </div>
                        </form>
                    </section>
                    <!-- <app-global-modal [firstPara]="firstPara" [scdPara]="scdPara" [showModal]="showModal"
                        (dialogAnswer)="deleteUserAccount($event)">
                    </app-global-modal> -->



                    <!-- MFA REQUEST BEFORE DELETING -->
                    <!-- <section class="container" *ngIf="doMFA">
                        <app-mfa *ngIf="isMFAEmail || !isMFAMobile" [title]="'Multi-Factor Authentication'"
                            [text]="'For your security, we have sent an authentication code to your email. Please retrieve it and enter it below to continue. You may have to check your junk inbox.'"
                            [textBtn]="'Verify and Delete'" [myUser]="myUser" [id]="id" [MFAFail]="MFAFail"
                            (submitEvent)="onSubmit()" (sendToLocationEvent)="sendToLocation($event)">
                        </app-mfa>

                        <app-mfa *ngIf="isMFAMobile" [title]="'Multi-Factor Authentication'"
                            [text]="'We have sent you a code via SMS. Enter it below to verify your mobile number.'"
                            [id]="id" [textBtn]="'Verify'" [myUser]="myUser" [MFAFail]="MFAFail" (submitEvent)="onSubmit()"
                            (sendToLocationEvent)="sendToLocation($event)" [isLogIn]="'isLogIn'">
                        </app-mfa>
                    </section> -->
                </section>
            </section>
        </section>
    </section>
</section>